import React from "react";
import Router from "../router/router";

function Layout() {
  return <Router />;
}

export default Layout;
